/**
 * Корневой контроллер оболочки приложения: состояние боковой панели, тема, признак «отдельной» страницы
 * (вход, первичная настройка, выход, страницы ошибок), на которой не показываются меню и подвал.
 */
const STANDALONE_STATES = ['shbdeployer.auth', 'shbdeployer.init.admin', 'shbdeployer.init.endpoint', 'shbdeployer.logout', 'shbdeployer.error'];
const MOBILE_VIEW_WIDTH = 992;

angular.module('shbdeployer.app').controller('MainController', [
  '$scope',
  '$state',
  'LocalStorage',
  'StateManager',
  'EndpointProvider',
  'ThemeManager',
  function ($scope, $state, LocalStorage, StateManager, EndpointProvider, ThemeManager) {
    $scope.getWidth = function () {
      return window.innerWidth;
    };

    $scope.applicationState = StateManager.getState();
    $scope.endpointState = EndpointProvider.endpoint();

    $scope.isStandalonePage = function () {
      const name = $state.current.name || '';
      return STANDALONE_STATES.some((state) => name === state || name.startsWith(`${state}.`));
    };

    $scope.$watch($scope.getWidth, function (newValue) {
      if (newValue >= MOBILE_VIEW_WIDTH) {
        const toggleValue = LocalStorage.getToolbarToggle();
        $scope.toggle = typeof toggleValue === 'boolean' ? toggleValue : true;
      } else {
        $scope.toggle = false;
      }
    });

    $scope.toggleSidebar = function () {
      $scope.toggle = !$scope.toggle;
      LocalStorage.storeToolbarToggle($scope.toggle);
    };

    window.onresize = function () {
      $scope.$apply();
    };

    ThemeManager.autoTheme();
  },
]);
